<template>
    <LeftSidebar v-if="showDesktopSidebar">
        <li class="nav-link" v-for="r in currentPc" :key="r.text">
            <router-link :to="url(r)" :title="r.text" :class="[isSelectUrl(url(r)) ? 'active' : '']">
        <span class="menu-icon" aria-hidden="true" v-html="r.svg"></span><span class="link-name">{{r.text}}</span>
            </router-link>
        </li>
    </LeftSidebar>
  <LeftSidebarMobile v-else-if="showResponsiveFooter" :items="currentMobile" :isActive="isSelectUrl" />
</template>
<script>
    import { Links } from '@/helpers/links';
    import { appData, C } from '@/helpers/global';
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';
    import LeftSidebar from '@/layouts/_partials/LeftSidebar.vue';
import LeftSidebarMobile from '@/layouts/_partials/LeftSidebar.mobile.vue';
    
    const svg=(body)=>`<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`;
    const I =
    {
        dashboard:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.69 54"><path fill="currentColor" d="M16.98,28.88c-.31-.04-.62-.12-.92-.23-1.26-.37-2.43-.99-3.43-1.83-.26-.21-.51-.44-.74-.69-1.87-1.89-2.92-4.44-2.92-7.1s1.05-5.21,2.92-7.1c1.87-1.88,4.42-2.94,7.08-2.95,1.32,0,2.62.25,3.83.75,1.22.5,2.32,1.24,3.25,2.16.93.93,1.67,2.03,2.18,3.25.51,1.21.77,2.52.77,3.83,0,1.32-.25,2.62-.75,3.83-.5,1.22-1.24,2.32-2.16,3.25-1.17,1.19-2.63,2.06-4.23,2.52-.62.17-1.25.28-1.89.34-.99.15-2,.13-2.98-.06ZM9.03,29.28l-1.55-1.54c-.06-.06-.11-.11-.11-.17-1.18-1.72-1.98-3.67-2.37-5.72-.38-2.05-.34-4.16.13-6.19.03-.23.09-.47.17-.69.06-.17.11-.29.17-.46.06-.06.06-.17.11-.23.51-1.38,1.23-2.67,2.12-3.83l-.06-.06-2.12-2.12c-.09-.09-.19-.17-.31-.21-.12-.05-.25-.06-.37-.05-.13.01-.25.05-.36.12-.11.07-.2.16-.27.26-2.07,2.86-3.26,6.26-3.43,9.79v1.66c.04,1.18.19,2.34.46,3.49v.11c.07.16.1.34.11.51l.17.51v.11c.18.65.41,1.28.69,1.89,0,0,0,.02,0,.02,0,0,0,.01.01.02,0,0,.01,0,.02.01,0,0,.01,0,.02,0,.11.29.23.51.34.8.12.2.21.41.29.63L.04,35.92c-.06.18-.06.38,0,.57.07.18.19.34.35.44.16.1.36.15.55.14.19-.02.38-.1.52-.23l.57-.57,4.12-4.12,2.75-2.75.11-.11ZM19.67,53.55c-.08.14-.19.25-.33.33-.14.08-.29.12-.45.12s-.31-.04-.45-.12c-.14-.08-.25-.19-.33-.33l-10.82-20.32-.06-.06,2.29-2.29c.14-.14.33-.23.52-.25.2-.02.4.03.56.14.46.34.97.63,1.43.97.06,0,.06.06.11.06.55.3,1.12.54,1.72.74.15.07.3.12.46.17.06,0,.17.06.23.06.97.3,1.97.51,2.98.63,1.69.15,3.39.01,5.04-.4.23-.06.4-.11.63-.17.59-.18,1.16-.41,1.72-.69.11-.06.17-.06.23-.11.11-.06.17-.06.29-.11.55-.29,1.09-.62,1.6-.98l.69-.51.86-.86.06-.06.34-.34,2.75,2.75,4.75,4.75c.13.14.21.32.23.52.02.19-.03.39-.14.55-.1.16-.26.29-.44.35-.18.07-.38.07-.57.01l-5.38-1.89c-.19-.07-.4-.07-.59,0-.19.07-.35.22-.44.4l-9.5,16.94ZM28.71,8.74l2.75-2.75,2.29-2.29,2.46-2.46c.14-.14.32-.22.52-.24.19-.02.39.03.56.13.16.11.29.26.35.45.06.18.07.39,0,.57l-2.8,7.95c.12.2.21.41.29.63.11.29.23.51.34.8,0,0,0,.02,0,.02s0,.01.01.02c0,0,.01,0,.02.01s.01,0,.02,0c.29.63.46,1.26.69,1.89v.11l.17.51c.07.16.1.34.11.51v.11c.67,2.73.69,5.58.06,8.32-.63,2.74-1.88,5.3-3.67,7.47l-.11-.11-2.29-2.29c-.15-.15-.23-.35-.24-.56-.01-.21.06-.42.19-.58.68-1.02,1.26-2.12,1.72-3.26.06-.06.06-.17.11-.23.06-.17.11-.29.17-.46.3-.95.51-1.93.63-2.92.05-.42.07-.84.06-1.26v-.97c0-.17-.06-.34-.06-.51-.36-3.18-1.79-6.15-4.06-8.41l-.23-.23h-.06ZM4.79,5.08L1.19,1.47c-.13-.14-.21-.32-.23-.52-.02-.19.03-.39.14-.55.1-.16.26-.29.44-.35.18-.07.38-.07.57,0l8.01,2.8c.18-.11.38-.2.57-.29l.69-.34c.06,0,.11-.06.17-.06.63-.29,1.28-.52,1.95-.69h.11c.16-.07.34-.1.51-.11.16-.07.34-.1.51-.11h.11c1.15-.26,2.32-.42,3.49-.45h.46c1.45,0,2.89.17,4.29.51h.06c.23.06.46.11.74.17.11.06.29.06.4.11.11.06.29.06.4.11.23.06.46.17.74.23h.06c1.53.59,2.97,1.38,4.28,2.34.1.08.18.17.24.29.06.11.09.23.09.36,0,.12-.02.25-.06.37-.05.12-.12.22-.21.31l-2.11,2.12-.06.06c-2.48-1.91-5.52-2.93-8.64-2.92-1.86-.01-3.71.35-5.43,1.07-1.72.72-3.28,1.77-4.58,3.11l-.06.06-.11-.11-2.8-2.69-1.14-1.2Z" /></svg>`,
        grid:svg('<rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/>'),
        coach:svg('<path d="M12 7v14"/><path d="M16 12h2"/><path d="M16 8h2"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/>'),
        lesson:svg('<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/><path d="M19 8h3"/><path d="M20.5 6.5v3"/>'),
        question:svg('<path d="M4 19.5V5a2 2 0 0 1 2-2h13a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a2 2 0 0 1 0-4h14"/><path d="M9.1 9a3 3 0 1 1 5.83 1c0 2-3 2-3 4"/><path d="M12 17h.01"/>'),
        play:svg('<rect width="18" height="14" x="3" y="5" rx="2"/><path d="m10 9 5 3-5 3Z"/>'),
        user:svg('<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>'),
        back:svg('<path d="m15 18-6-6 6-6"/><path d="M9 12h11"/>'),
        calendar:svg('<path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/>'),
        clock:svg('<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>')
    };
    export default {
        props: ['type'],
        components: {
            LeftSidebar,
            LeftSidebarMobile
        },
        setup() {
            const route= useRoute();
            return {
                appData,
                isPrivateLesson: computed(() => route.path.indexOf('/panel/ozel-ders') === 0),
                isCoaching: computed(() => route.path.indexOf('/panel/kocluk') === 0),
                isDashboard: computed(() => route.path === '/panel' || route.path === '/panel/')
            }
        },
        computed: {
            currentPc() {
                return this.isPrivateLesson ? this.privateLessonPc : this.pc
            },
            showDesktopSidebar() {
                return !this.appData.isMobile
            },
            showResponsiveFooter() {
                return !this.isDashboard && this.appData.isMobile
            },
            showMobileFooter() {
                return !this.isDashboard
            },
            currentMobile() {
                return this.isPrivateLesson ? this.privateLessonMobile : this.primaryMobile
            }
        },
        data() {
            return {
                pc: [
                    { svg: I.grid, link: Links.Dashboard, text: 'Panelim' },
                    { svg: I.coach, path: '/panel/kocluk', text: 'Koçluk' },
                    //{ svg: I.lesson, path: '/panel/ozel-ders', text: 'Özel Ders' },
                    //{ svg: I.question, path: '/panel/soru-havuzu', text: 'Soru Havuzu' },
                    { svg: I.play, path: '/panel/kullanim-kilavuzu', text: 'Kullanım Kılavuzu' },
                    { svg: I.user, link: Links.User.Profile, text: 'Hesabım' }
                ],
                mobile:[],
                primaryMobile:[
                    { svg: I.coach, path: '/panel/kocluk', text: 'Koçluk' },
                    null,
                    //{ svg: I.lesson, path: '/panel/ozel-ders', text: 'Özel Ders' },
                    { kind: 'dashboard', svg: I.dashboard, link: Links.Dashboard, text: 'Panelim' },
                    //{ svg: I.question, path: '/panel/soru-havuzu', text: 'Sorular' },
                    { svg: I.user, link: Links.User.Profile, text: 'Hesabım' }
                ],
                privateLessonPc: [
                    { svg: I.back, path: '/panel', text: 'Ana Panele Dön' },
                    { svg: I.lesson, path: '/panel/ozel-ders', text: 'Ders Al' },
                    { svg: I.calendar, path: '/panel/ozel-ders/planli', text: 'Planlı Dersler' },
                    { svg: I.clock, path: '/panel/ozel-ders/gecmis', text: 'Geçmiş Dersler' }
                ],
                privateLessonMobile:[
                    { svg: I.lesson, path: '/panel/ozel-ders', text: 'Ders Al' },
                    { svg: I.calendar, path: '/panel/ozel-ders/planli', text: 'Planlı Dersler' },
                    { kind: 'dashboard', svg: I.dashboard, link: Links.Dashboard, text: 'Panelim' },
                    { svg: I.clock, path: '/panel/ozel-ders/gecmis', text: 'Geçmiş Dersler' },
                    { svg: I.user, link: Links.User.Profile, text: 'Hesabım' }
                ]
            }
        },
        methods: {
            url(r) {
                return r.path || Links.Url(r.link, r.args)
            },
            isSelectUrl(link) {
                const current= C.Str(this.$route.path).replace(/\/$/,'')||'/';
                const target= C.Str(link).replace(/\/0/g,'').replace(/\/$/,'')||'/';

                // Panel yalnızca ana panelde aktif olsun.
                if (target === '/panel') {
                    return current === '/panel';
                }
                // Özel ders ana ekranı yalnızca öğretmen listesinde aktif olsun.
                if (target === '/panel/ozel-ders') {
                    return current === '/panel/ozel-ders';
                }
                // Planlı ders yalnızca kendi ekranında aktif olsun.
                if (target === '/panel/ozel-ders/planli') {
                    return current === '/panel/ozel-ders/planli';
                }

                // Geçmiş ders detayları da Geçmiş Dersler altında aktif kalsın.
                if(target==='/panel/ozel-ders/gecmis')
                {
                    return current === '/panel/ozel-ders/gecmis' || current.indexOf('/panel/ozel-ders/gecmis/') === 0;
                }

                // Diğer menülerde tam route eşleşmesi kullan.
                return current===target;
            }
        }
    }
</script>
